"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CANVAS_IFRAME", {
  enumerable: true,
  get: function get() {
    return _constants.CANVAS_IFRAME;
  }
});

var _tinymce = _interopRequireDefault(require("tinymce"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _colors = require("HubStyleTokens/colors");

var _constants = require("../constants");

var _toolbar = require("../constants/toolbar");

var _IframeToolbar = _interopRequireDefault(require("../components/IframeToolbar"));

var _namespace = require("../utils/namespace");

var _canvas = require("./ui/canvas");

_tinymce.default.ThemeManager.add(_constants.CANVAS_IFRAME, function (editor) {
  var renderUI = function renderUI(_ref) {
    var targetNode = _ref.targetNode;
    editor.fire('BeforeRenderUI');
    var editorContainer = document.createElement('div');
    var iframeContainer = document.createElement('div');
    var toolbarContainer = document.createElement('div');
    editorContainer.setAttribute('role', 'application');
    editorContainer.setAttribute('tabIndex', '-1');
    editorContainer.style.borderRadius = '2px';
    editorContainer.style.border = "1px solid " + _colors.BATTLESHIP;
    editorContainer.appendChild(toolbarContainer);
    editorContainer.appendChild(iframeContainer);
    targetNode.parentNode.insertBefore(editorContainer, targetNode);
    editor.on('init', function () {
      _reactDom.default.render(_react.default.createElement(_IframeToolbar.default, {
        editor: editor,
        toolbar: editor.settings.canvasToolbar,
        getUserAttributes: editor.settings[_toolbar.GET_USER_ATTRIBUTES],
        setUserAttribute: editor.settings[_toolbar.SET_USER_ATTRIBUTE],
        showToolbarShepherd: editor.settings[_toolbar.SHOW_TOOLBAR_SHEPHERD],
        namespace: (0, _namespace.getNamespace)(editor),
        shepherdClassName: "mce-shepherd"
      }), toolbarContainer);
    });
    editor.on('remove', function () {
      _reactDom.default.unmountComponentAtNode(toolbarContainer);

      editorContainer.parentNode.removeChild(editorContainer);
    });
    return {
      iframeContainer: iframeContainer,
      editorContainer: editorContainer
    };
  };

  return {
    renderUI: renderUI,
    getWindowManagerImpl: (0, _canvas.getWindowManagerImpl)(editor),
    getNotificationManagerImpl: (0, _canvas.getNotificationManagerImpl)(editor)
  };
});